export default function Strore(props: any) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M20.5 11.5V19.5C20.5 20.0523 20.0523 20.5 19.5 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5V11.5"
                stroke="#010101"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M14.5 15.5H10.5V20.5H14.5V15.5Z" stroke="#010101" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 3.5H15.5V8.5C15.5 10.1569 14.1569 11.5 12.5 11.5C10.8431 11.5 9.5 10.1569 9.5 8.5V3.5Z"
                stroke="#010101"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.99999 3.5H9.49999V8C9.49999 9.933 7.93299 11.5 5.99999 11.5C4.73578 11.5 3.71094 10.4752 3.71094 9.21095C3.71094 8.89515 3.77628 8.58277 3.90286 8.29345L5.99999 3.5Z"
                stroke="#010101"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5 3.5H19L21.0971 8.29345C21.6039 9.45166 21.0757 10.8014 19.9175 11.3081C19.6282 11.4347 19.3158 11.5 19 11.5C17.067 11.5 15.5 9.933 15.5 8V3.5Z"
                stroke="#010101"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
